import { render, staticRenderFns } from "./Slide3.vue?vue&type=template&id=6035cc15&scoped=true&"
import script from "./Slide3.vue?vue&type=script&lang=ts&"
export * from "./Slide3.vue?vue&type=script&lang=ts&"
import style0 from "./Slide3.vue?vue&type=style&index=0&id=6035cc15&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6035cc15",
  null
  
)

export default component.exports